import api from "./api";

// -------------------- VARIETIES --------------------
export const fetchVarieties = async () => {
  const res = await api.get("/core/varieties/");
  return res.data;
};

export const createVariety = async (variety) => {
  const res = await api.post("/core/varieties/", variety);
  return res.data;
};

export const updateVariety = async (id, variety) => {
  const res = await api.put(`/core/varieties/${id}/`, variety);
  return res.data;
};

export const deleteVariety = async (id) => {
  const res = await api.delete(`/core/varieties/${id}/`);
  return res.data;
};